<video #backgroundVideo autoplay muted loop playsinline class="background-video" preload="auto">
  <source src="/assets/videos/quantro.io video 1.mp4" type="video/mp4">
</video>
<!-- <img src="/assets/banner.png" alt=""> -->
<div class="login-container">
  <div class="login-section">
    <div class="main-section">
      @if (!url) {
        <div class="headlines">
          <h4 class="w-100 d-block m-2">Where Operation meets organization</h4>
          <h1 class="w-100 d-block m-0">Control Every <strong class="q-color">Operation</strong>.</h1>
          <h1 class="w-100 d-block m-0">From Booking to Payroll.</h1>
        </div>
      } @else if (url ) {
        <div class="login-form">
          <form [formGroup]="loginForm" (ngSubmit)="submit()" class="login-row" novalidate>
            <!-- EMAIL -->
             <div class="">
              <label class="pill me-2">
                <input type="email" class="custom-input" placeholder="Enter Email ID"
                       formControlName="email" autocomplete="username" />
              </label>
              <div class="err" *ngIf="dirty('email') && loginForm.controls['email'].errors">
                <span *ngIf="loginForm.controls['email'].hasError('required')">Email is required.</span>
                <span *ngIf="loginForm.controls['email'].hasError('email')">Enter a valid email.</span>
              </div>
             </div>



            <!-- PASSWORD -->
             <div class="">
              <label class="pill me-3">
                <input class="custom-input" [type]="showPwd() ? 'text' : 'password'"
                       placeholder="Enter Password"
                       formControlName="password"
                       autocomplete="current-password" />
                <button type="button" class="eye" (click)="togglePwd()"
                        [attr.aria-label]="showPwd() ? 'Hide password' : 'Show password'">
                  <i *ngIf="!showPwd()" class="fa text-white fa-eye-slash"></i> <i *ngIf="showPwd()" class="fa text-white fa-eye"></i>
                </button>
              </label>
              <div class="err" *ngIf="dirty('password') && loginForm.controls['password'].errors">
                <span *ngIf="loginForm.controls['password'].hasError('required')">Password is required.</span>
                <span *ngIf="loginForm.controls['password'].hasError('minlength')">Min 6 characters.</span>
              </div>
             </div>


            <!-- LOGIN -->
            <button class="cta" type="submit" [disabled]="loginForm.invalid || loading()">
              <span *ngIf="!loading()">Login</span>
              <span class="btn-loader" *ngIf="loading()"></span>
            </button>

            <div class="api-error" *ngIf="apiError()">{{ apiError() }}</div>
          </form>
        </div>
      }


    </div>
    <div class="logo">
      <img src="/assets/images/quantol.io logo.svg" alt="">
    </div>
    <!-- <div class="login-nav-button">
      <button class="">Log In</button>
    </div> -->
    <div class="fillers w-100">
      <div class="d-flex w-100 justify-content-center align-items-center p-5">
        <div class="headlines fillers-head">
          @if(url) {
          <h4 class="w-100 text-start d-block m-2">Where Operation meets organization</h4>
          <h1 class="w-100 text-start d-block m-0">Control Every <strong class="q-color">Operation</strong>.</h1>
          <h1 class="w-100 text-start d-block m-0">From Booking to Payroll.</h1>
          } @else if(!url) {
            <div class="login-nav-button">
              <button routerLink="login" class="">Log In</button>
            </div>
          }
        </div>
        <div class="buttons">
          <button class="touch">Get in touch <img src="/assets/icons/arrow (quantrol.io).svg" alt=""></button>
          <button class="learn-more">Learn More</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="false" class="filler-section">
    <div class="learn-more-section">
      <div class="learn-more-container">
        <div class="d-flex w-100">
          <div class="text-section">
            <strong class="q-color">Q</strong>uontrol is your smart back-office plartform tailored for travel and
            service business.
            <br>
            Manage bookings, teams and expenses from a single dashboard
          </div>
          <div class="arrow-section">
            <div class="arrow">
              <img src="/assets/images/big arrow (quantrol.io).svg" alt="">
            </div>

          </div>
        </div>
        <div class="d-flex justify-content-end align-items-center text-button-section">
          <div class="w-40">
            <div class="text mb-3">We built <strong class="q-color">Q</strong>uontrol to provide your business with
              solution that make work easier, so you can enjoy life more.</div>
            <button class="button">Learn More</button>
          </div>
        </div>

      </div>
    </div>
    <div class="innovation-section">
      <div class="innovation-container">
        <div class="innovation-head">
          <h1>Innovation <br> that flows</h1>
        </div>
        <div class="innovation-body">
          <div class="innovation-text">
            <h2 class="w-100 d-block">Seamless Integration</h2>
            <p class="w-100 d-block m-0">What's special about your product, service, or company? Use this
              space to highlight the things that set you apart from your
              competition, whether it's a special feature, a unique philosophy, or
              awards and recognition that you have received. Think of this as
              your elevator pitch to get the reader's attention.</p>
          </div>
          <div class="innovation-border"></div>
          <div class="innovation-text">
            <h2 class="w-100 d-block ">Intuitive user interface</h2>
            <p class="w-100 d-block m-0">What's special about your product, service, or company? Use this
              space to highlight the things that set you apart from your
              competition.</p>
          </div>
          <div class="innovation-border "></div>
          <div class="innovation-text">
            <h2 class="w-100 d-block">Excellent customer
              support</h2>
            <p class="w-100 d-block m-0">Use this space to highlight the things that set you apart from your
              competition, whether it's a special feature, a unique philosophy, or
              awards and recognition that you have received. Think of this as
              your elevator pitch to get the reader's attention.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="explore-section">
      <div class="explore-container">
        <div class="why-choose-section">
          <div class="highlights">
            <div class="highlight-img">
              <img src="/assets/images/Accounting Software (quantrol.io).svg" alt="">
            </div>
            <h2>Accounting
              Software</h2>
            <p>
              Give a detailed description of the
              service being provided here.
            </p>
          </div>
          <div class="highlights">
            <div class="highlight-img">
              <img src="/assets/images/HR & Payroll System (qunatrol.io).svg" alt="">
            </div>
            <h2>HR & Payroll
              System</h2>
            <p>
              Give a detailed description of the
              service being provided here.
            </p>
          </div>
          <div class="highlights">
            <div class="highlight-img">
              <img src="/assets/images/Inventory Management (quantrol.io).svg" alt="">
            </div>
            <h2>Inventory
              Management</h2>
            <p>
              Give a detailed description of the
              service being provided here.
            </p>
          </div>
        </div>
        <div class="explore-button">
          <button class="explore">Explore</button>
        </div>
      </div>
    </div>
    <div class="globe-image-section">
      <div class="globe-image-container">
        <div class="image-text-section">
          <h1>Simplifying my business
            processes with Schematiq freed
            up time for me to focus on
            expansion.</h1>
          <p>Testimonials are shortquotes from people who love your
            brand. It's a great way to convince customers to try your
            services.</p>
          <h5>Miguel Rivera, OnlineBusiness Owner</h5>
        </div>
        <div class="image-section">
          <video #backgroundVideo autoplay muted loop playsinline preload="auto">
            <source src="/assets/videos/quantro.io video (500-500).mp4" type="video/mp4">
          </video>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="footer-container">
       <div class="footer-right">
        <div class="footer-logo mb-5">
          <img src="/assets/images/quantol.io logo.svg" alt="">
        </div>
        <h2 class="mb-3">Innovate with us</h2>
        <h5 class="mb-4">Automate and simplify your business
          operations with easy and secure
          solutions</h5>
        <div class="start-today-button">
          <button>START TODAY</button>
        </div>
       </div>
       <div class="footer-left">
        <!-- <div class="footer-links">
          <div class="footer-link">
            <h5>Company</h5>
            <ul>
              <li>About Us</li>
              <li>Careers</li>
              <li>Contact Us</li>
              <li>Blog</li>
            </ul>
          </div>
          <div class="footer-link">
            <h5>Solutions</h5>
            <ul>
              <li>Accounting Software</li>
              <li>HR & Payroll System</li>
              <li>Inventory Management</li>
            </ul>
          </div>

       </div> -->
       <div class="footer-socials">
        <h2>Get Social</h2>
        <img src="/assets/images/facebook (white) 1.svg" alt="">
        <img src="/assets/images/instagram (white) 1.svg" alt="">
        <img src="/assets/images/twitter (white) 1.svg" alt="">
      </div>


      </div>
    </div>
  </div>

</div>
